<!--Copy right - © 2024 tecera gmbh-->
<script>
export let field_data;
export let input_value;
function clear_input() {
    input_value =null;
}
$: disabled = (input_value == null||input_value == "") ? true : false;

</script>


<div class="input-group mb-2 mt-2">
    <input
        bind:value={input_value}
        id={field_data.id}
        class="form-control py-1 edit_field"
        list={field_data.list_id}
        type="text"
        placeholder={field_data.placeholder}
        aria-label="Search"
        maxlength="50"
        autocomplete="off"
    />
    <button
        class="btn bg-transparent btn-clear"
        class:hidden={disabled}
        on:click={clear_input}
    >
        <i class="fa fa-times"></i>
    </button>
    <datalist id={field_data.list_id}></datalist>
</div>